import { useEffect, useState } from "react"

const useToken = user => {
    const [token, setToken] = useState('');
    useEffect(() => {
        console.log('user inside use token', user);
        const email = user?.user?.email;
        const currentUser = { email: email };
        if (email) {
            fetch(`https://mysterious-wildwood-08866.herokuapp.com/user/${email}`, {
                method: 'PUT',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify(currentUser)
            })
                .then(res => res.json())
                .then(data => {
                    console.log('data inside use Token', data);
                    const accessToken = data.accessToken;
                    localStorage.setItem('accessToken', accessToken)
                    setToken(accessToken);
                })

        }
    }, [user])
    return [token]
}
export default useToken;